import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { currentUserAgreementAtom } from "./store";
import { ReactElement, useState } from "react";
import { Button, Checkbox, Heading, Image, VStack } from "@chakra-ui/react";
import { Layout } from "./components/atoms/Layout";
import appImageImageUrl from "./assets/images/mci/app_image01.png";
import { useTranslation } from "react-i18next";
import { BannerImage } from "./components/atoms/BannerImage";
import PrivacyPolicyBox from "./privacyPolicy";
import TermsOfUseBox from "./termOfService";

export function UserAgreement(): ReactElement {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [, setHasAgreed] = useAtom(currentUserAgreementAtom);

  const handleAgree = (): void => {
    setHasAgreed(true);
    navigate(`/${i18n.language}/home`);
  };

  return (
    <Layout
      minHeight="100%"
      paddingY={{ base: 5, md: 12 }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      {/* App Banner */}
      <Layout.Title showBackToHomeButton={false} fontSize="24px">
        <BannerImage />
      </Layout.Title>
      <VStack>
        <Image src={appImageImageUrl} alt="Banner" boxSize="150px" />
      </VStack>
      <VStack>
        <Heading size="sm" textAlign="center">
          本アプリの利用条件に同意してください
        </Heading>
      </VStack>
      <VStack spacing={4} my={4} px={4}>
        <TermsOfUseBox />
      </VStack>
      <VStack spacing={4} my={4} px={4}>
        <PrivacyPolicyBox />
      </VStack>
      <VStack spacing={4} my={4} px={4}>
        <Checkbox
          size="sm"
          isChecked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        >
          利用規約・プライバシーポリシーに同意する
        </Checkbox>
      </VStack>

      <Button
        variant="btn_primary"
        w="full"
        onClick={handleAgree}
        isDisabled={!checked}
      >
        利用規約・プライバシーポリシーに同意する
      </Button>
    </Layout>
  );
}
